import MainContainer from "../../components/MainContainer";
import { headerMyDataImmo } from "../../data/modules/my-materials-header";
import { makeStyles } from "@material-ui/core/styles";
import { useState, useEffect, useRef, useContext } from "react";
import UserService from '../../services/UserService';
import { Grid, Paper } from "@material-ui/core";
import { Button } from "@material-ui/core";
import Spacer from "../../components/Spacer";
import InventoryMineTable from "./InventoryMineTable";
import InventoryService from "../../services/InventoryService";
const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    elevation: 0,
  },
  style1: {
    fontSize: "5em",
  },
}));
export default function InventoryMineList() {
  const [acceptButton, setAcceptButton] = useState(true);
  const [isDisabled, setIsDisabled] = useState(false);
  const classes = useStyles();
  const [rows, setRows] = useState([]);
  const [message, setMessage] = useState({
    open: false,
    color: 'green',
    messageInfo: '',
  });
  const messageRef = useRef(null);

  // Fonction pour scroller vers le message
  const scrollToMessage = () => {
      setTimeout(() => {
          if (messageRef.current) {
              messageRef.current.scrollIntoView({ 
                  behavior: 'smooth', 
                  block: 'center' 
              });
          }
      }, 100);
  };
  const { open, color, messageInfo } = message;

  const wscols = [
    { wch: 25 },
    { wch: 25 },
    { wch: 45 },
    { wch: 15 },
    { wch: 25 },
    { wch: 25 },
    { wch: 45 },
    { wch: 10 },
    { wch: 25 },
  ];

  const wscolsDetenteur = [
    { wch: 25 },
    { wch: 25 },
    { wch: 45 },
    { wch: 45 },
    { wch: 10 },
    { wch: 10 },
    { wch: 10 },
  ];

  const downloadPDF = () => {
    var user_id = localStorage.getItem("USER");
    InventoryService.generateSignedPDf(user_id).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      const extension = 'pdf';
      const fileName = 'Fiche_de_detention';
      var user_id = localStorage.getItem("USER");
        
      const uniqueFileName = `${fileName}_${user_id}.${extension}`;
      a.download = uniqueFileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    })
      .catch((error) => {
        console.error('Erreur lors du téléchargement du PDF :', error);
      });
  };

  function downloadClickAffectedSheet() {
    var user_id = localStorage.getItem("USER");
    InventoryService.downloadAffectationSheetByUserPDf(user_id).then((response) => {     
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      const extension = 'pdf';
      const fileName = 'Fiche_daffectation';
        
      const uniqueFileName = `${fileName}_${user_id}.${extension}`;
      a.download = uniqueFileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
        setMessage({
            ...message,
            open: true,
            color: "green",
            messageInfo: "Succès de téléchargent de la fiche d'affectation",
        });
    })
    .catch((error) => {
        console.warn('Le fichier n\'existe pas sur le serveur.Erreur lors du téléchargement du PDF :', error);
        
        scrollToMessage();
        setMessage({
            ...message,
            open: true,
            color: "red",
            messageInfo: "Le fichier n\'existe pas sur le serveur. Merci de contacter le service logistique en cas de besoin.",
        });
    });
  }

  function handleCloseMessage() {
    setMessage({ ...message, open: false });
  }
  useEffect(() => {
    var countList = InventoryService.getCountMineImmoHistory().then((result) => {
      if (result && result.status) {
          setAcceptButton(true);
      } else {
        setAcceptButton(false);
      }
    });
    
  }, []);

  return (
    <>
      <MainContainer {...headerMyDataImmo}>
        {message.open && (
                <div style={{
                    backgroundColor: message.color === 'red' ? '#f44336' : '#4caf50',
                    color: 'white',
                    padding: '15px',
                    borderRadius: '5px',
                    margin: '10px 0',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    <span>{message.messageInfo}</span>
                    <button 
                        onClick={() => setMessage({...message, open: false})}
                        style={{
                            background: 'transparent',
                            border: 'none',
                            color: 'white',
                            fontSize: '20px',
                            cursor: 'pointer',
                            marginLeft: '20px'
                        }}
                    >
                        ✕
                    </button>
                </div>
            )}
        <Grid container item xs={12}>
          <Spacer x={2} />
          { acceptButton
          && (
            <Button
              variant="contained"
              color="primary"
              onClick={downloadClickAffectedSheet}
              style={{ fontWeight: 600, marginLeft: "auto", backgroundColor:"green"} }
            >Fiche d'affectation
            </Button>
          )}
          <Spacer x={2} />
          { acceptButton
          && (
            <Button
              variant="contained"
              color="primary"
              onClick={downloadPDF}
              style={{ fontWeight: 600 }}
            >Fiche de détention
            </Button>
          )}
        </Grid>

        <Spacer y={2} />

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Paper className={classes.paper} variant="outlined">
              <InventoryMineTable />
            </Paper>
          </Grid>
        </Grid>
      </MainContainer>

      
    </>

  );
}
